import { render, staticRenderFns } from "./TransferBetweenAgentTable.vue?vue&type=template&id=38c02675&"
import script from "./TransferBetweenAgentTable.vue?vue&type=script&lang=js&"
export * from "./TransferBetweenAgentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports